import { StyleSheet } from "react-native";
import { theme } from "../../theme";
export const styles = StyleSheet.create(Object.assign({
    text: {
        textAlign: "center",
        fontFamily: "Proxima",
        marginTop: theme.spacing.xsmall,
    },
    loader: {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
    },
    beeLogo: {
        position: "absolute",
        width: theme.spacing.large,
        height: theme.spacing.large,
        left: theme.spacing.xlarge2,
        top: 44,
    },
}, ...Object.entries(theme.colors).map(([accessor, { base }]) => ({
    [accessor]: { color: base },
}))));
//# sourceMappingURL=Loader.styles.js.map